/**
 * Text color Style
 */
var TextStyle;
(function (TextStyle) {
    TextStyle["MAIN"] = "MAIN";
    TextStyle["ACCENT"] = "ACCENT";
    TextStyle["INFO"] = "INFO";
})(TextStyle || (TextStyle = {}));
/**
 * Returns text's classname depending on text type
 * @param textType {string} - Text type
 * @returns {string} - Text value
 */
export var getTextClassName = function (textType) {
    switch (textType) {
        case "MAIN":
            return "text-main";
        case "ACCENT":
            return "text-accent";
        case "INFO":
            return "text-info";
        case "WHITE":
            return "text-white";
        case "NEUTRAL":
            return "text-neutral";
        case "SUCCESS":
            return "text-success";
        case "WARNING":
            return "text-warning";
        case "ERROR":
            return "text-error";
        default:
            return "";
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL29iamVjdHMvYXRvbXMvVGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILElBQUssU0FJSjtBQUpELFdBQUssU0FBUztJQUNaLDBCQUFhLENBQUE7SUFDYiw4QkFBaUIsQ0FBQTtJQUNqQiwwQkFBYSxDQUFBO0FBQ2YsQ0FBQyxFQUpJLFNBQVMsS0FBVCxTQUFTLFFBSWI7QUFTRDs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLElBQU0sZ0JBQWdCLEdBQUcsVUFBQyxRQUFpQjtJQUNoRCxRQUFRLFFBQVEsRUFBRTtRQUNoQixLQUFLLE1BQU07WUFDVCxPQUFPLFdBQVcsQ0FBQTtRQUNwQixLQUFLLFFBQVE7WUFDWCxPQUFPLGFBQWEsQ0FBQTtRQUN0QixLQUFLLE1BQU07WUFDVCxPQUFPLFdBQVcsQ0FBQTtRQUNwQixLQUFLLE9BQU87WUFDVixPQUFPLFlBQVksQ0FBQTtRQUNyQixLQUFLLFNBQVM7WUFDWixPQUFPLGNBQWMsQ0FBQTtRQUN2QixLQUFLLFNBQVM7WUFDWixPQUFPLGNBQWMsQ0FBQTtRQUN2QixLQUFLLFNBQVM7WUFDWixPQUFPLGNBQWMsQ0FBQTtRQUN2QixLQUFLLE9BQU87WUFDVixPQUFPLFlBQVksQ0FBQTtRQUNyQjtZQUNFLE9BQU8sRUFBRSxDQUFBO0tBQ1o7QUFDSCxDQUFDLENBQUEifQ==